import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/store';

const selector = (state: RootState) => state.upload;

const uploadData = createSelector([selector], (state) => state);

export default {
  uploadData
};
